import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import styles from './ProductContent.module.scss';
import A from './comps/A';
import B from './comps/B';
import C from './comps/C';
import D from './comps/D';
import E from './comps/E';
import F from './comps/F';
import G from './comps/G';
import H from './comps/H';
import I from './comps/I';
import J from './comps/J';
import K from './comps/K';
import L from './comps/L';
import { useProductStore } from './../ProductProvider';
import { useEffect } from 'react';
import gtm from '@/utils/gtm';

export default function Teaser() {
    const { locale } = useRouter();
    const { pageStatus } = useProductStore();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const onPlayerStateChange = (event, n) => {
                if (event.data === window.YT.PlayerState.PLAYING) {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'video',
                        title_name:
                            n === 1
                                ? 'EcoFlow 12V 100Ah Lithium Battery | Upgrade for Endless Adventures'
                                : n === 2
                                ? 'EcoFlow Power Hat: Power all your adventures'
                                : '',
                        position: `Product Detail_${n}`,
                    });
                }
            };

            // 通过 YouTube IFrame API 创建播放器
            window.onYouTubeIframeAPIReady = () => {
                setTimeout(() => {
                    const func = () => {
                        const t1 = document.getElementById('player-hat1') as HTMLDivElement;
                        const t2 = document.getElementById('player-hat2') as HTMLDivElement;
                        if (t1 && window.YT) {
                            const player1 = new window.YT.Player(t1, {
                                videoId: '-ndnP7o5u9I',
                                playerVars: {
                                    autoplay: 1,
                                    playsinline: 1,
                                    modestbranding: 1, // 减少 YouTube 品牌标识
                                    rel: 0, // 不显示相关视频
                                    enablejsapi: 1, // 启用 JavaScript API
                                },
                                events: {
                                    onStateChange: (event) => onPlayerStateChange(event, 1),
                                    onReady: (event) => {
                                        console.log('Player ready');
                                        event.target.playVideo();
                                    },
                                    onError: (event) => {
                                        console.error('Error loading video:', event);
                                    },
                                },
                            });

                            console.log('p1', player1);
                        }
                        if (t2 && window.YT) {
                            const player2 = new window.YT.Player(t2, {
                                videoId: 'CTTUN14F44o',
                                playerVars: {
                                    autoplay: 1,
                                    playsinline: 1,
                                },
                                events: {
                                    onStateChange: (event) => onPlayerStateChange(event, 2),
                                },
                            });
                        }
                    };
                    func();
                }, 1000);
            };

            return () => {
                window.onYouTubeIframeAPIReady = null;
            };
        }
    }, []);

    const RenderPageContent = () => {
        return (
            <>
                <A />
                <B />
                <EfSpec className="spec-x" />
                {pageStatus === 'statusA' && <C />}
                <div className="bg-sec">
                    {/* 帽子 */}
                    <G />
                    <H />
                    <I />
                    {/* 12V电池 */}
                    <D />
                    <E />
                    <F />
                    <EfSpec className="spec-x" />
                </div>
                <J />
                <K />
                <L />
            </>
        );
    };

    return (
        <div className={styles.teaser}>
            <RenderPageContent />
        </div>
    );
}
